import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { IRoute, routesByViewID } from "../../routes/routes";
import { NavigationSource } from "../../common/enums/NavigationSource";
import useNavigateTo from "../use-navigate-to/useNavigateTo";

export type TabListItemType<TKey> = { key: TKey; route: IRoute; };
export type TabListType<TKey> = Array<TabListItemType<TKey>>;
export type SetActiveTabFunctionType<TKey> = (key: TKey, replace?: boolean) => void;

export default function useTabs<TKey extends number | string>(storageKey: string, tabList: TabListType<TKey>, initialTab: TKey): [activeTab: TKey, setActiveTab: SetActiveTabFunctionType<TKey>] {
    const location = useLocation();
    const navigateTo = useNavigateTo();
    const [tab, setTab] = useState<TKey>(initialTab);
    // const [tabState, setTabState] = useState<Record<TKey, any>>();
    // const routeMatch = useRouteMatch(
    //     tabList
    //         .filter(entry => entry.route.fullPath)
    //         .map(entry => entry.route.fullPath as string)
    // );

    useEffect(() => {
        // const entry = tabList.find(entry => entry.route.fullPath === routeMatch?.path);
        const entry = tabList.find(entry => entry.route.fullPath === location?.pathname);

        if (entry) {
            setTab(entry?.key);
        } else {

            const viewID = Number.parseInt(localStorage.getItem(`lastTab:${storageKey}`) ?? "");
            const route = Number.isFinite(viewID)
                ? routesByViewID.get(Number(viewID))
                : undefined;

            if (route) {
                const entry = tabList.find(entry => entry.route === route);
                if (entry) {
                    navigateTo(`${entry.route.path}${location.search}`, { replace: true });
                    setTab(entry?.key);
                }

            } else {
                const entry = tabList.find(entry => entry.key === initialTab);
                if (entry) {
                    navigateTo(`${entry.route.path}${location.search}`, { replace: true });
                    setTab(entry?.key);
                }
            }
        }

    }, [
        tabList,
        //routeMatch?.path,
        location.pathname,
        initialTab,
        location.search,
        storageKey,
        navigateTo
    ]);

    const setActiveTab = useCallback((key: TKey, replace?: boolean) => {
        const entry = tabList.find(entry => entry.key === key);
        if (entry) {

            localStorage.setItem(`lastTab:${storageKey}`, entry.route.viewID?.toString() ?? "");

            // make a copy of the current tab state
            // setTabState(tabState => {
            //     const copy = {...tabState} as Record<TKey, any>;
            //     copy[tab] = history.location.state;

            //     console.log(`#### useTabs setActiveTab storing current state ${JSON.stringify(copy)}`)

            //     return copy;
            // });

            // const state = tabState ? tabState[key] : undefined;

            // console.log(`#### useTabs setActiveTab restoring last state = ${JSON.stringify(state)}`)


            // When switching tabs, change/add the nav source
            const search = location.search
                .replace(/&navSrc=\d*/, "")
                .concat(`&navSrc=${NavigationSource.Tab}`);

            navigateTo(`${entry.route.path}${search}`, { replace: replace });
        }
    }, [
        navigateTo,
        location.search,
        tabList,
        storageKey,
        //tabState,
        //tab
    ]);

    return [tab, setActiveTab];
}